import { StyledIconButtonContainer } from '@Components/Buttons/IconButton/styled';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

type Props = {
	icon: React.ReactNode;
	tooltipText: string;
	size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
	selected?: boolean;
	isActive?: string;
	isButton?: string;
} & React.ButtonHTMLAttributes<HTMLDivElement>;

function getSizeInPixels(size: Props['size']) {
	switch (size) {
		case 'xs':
			return 16;
		case 'sm':
			return 24;
		case 'md':
			return 32;
		case 'lg':
			return 48;
		case 'xl':
			return 64;
		default:
			return 32;
	}
}

export default function IconButton({
	icon,
	tooltipText,
	size = 'md',
	style,
	isActive = 'btn-active-light-primary',
	isButton = 'btn-light',
	...buttonProps
}: Props) {
	return (
		<OverlayTrigger
			placement="bottom"
			overlay={<Tooltip id={'tooltip-bottom'}>{tooltipText}</Tooltip>}
		>
			<StyledIconButtonContainer
				className={`btn btn-icon ${isButton} ${isActive}`}
				style={{
					...style,
					width: getSizeInPixels(size),
					height: getSizeInPixels(size),
				}}
				{...buttonProps}
			>
				{icon}
			</StyledIconButtonContainer>
		</OverlayTrigger>
	);
}
